/**
 * @flow
 */

import React from 'react'
import PlayInStadium from '../../../Icons/PlayInStadium'
import BringOutCricketerInYou from '../../../Icons/BringOutCricketerInYou'
import CompeteWithYourFriends from '../../../Icons/CompeteWithYourFriends'
import BeAVrCricketStar from '../../../Icons/BeAVrCricketStar'
import Colors from '../../../themes/Colors'
import {
  PlayInInternationalStadiumStripSection,
  PlayInInternationalStadiumStripContainer,
  PlayInInternationalStadiumInnerContainer,
  PlayInInternationalStadiumText,
  PlayInInternationalStadiumSvgContainer,
  PlayInStripContainer
} from './styledComponents'
import {
  PLAY_IN_STADIUM_ICON,
  BRING_OUT_CRICKETER_IN_YOU_ICON,
  COMPETE_WITH_YOUR_FRIENDS_ICON,
  BE_A_VR_CRICKETER_ICON
} from './constants'

class PlayInInternationalStadiumStrip extends React.Component<Props> {
  getIcon = iconData => {
    switch (iconData) {
      case PLAY_IN_STADIUM_ICON:
        return <PlayInStadium fill={Colors.whiteTwo} />
      case BRING_OUT_CRICKETER_IN_YOU_ICON:
        return <BringOutCricketerInYou fill={Colors.whiteTwo} />
      case COMPETE_WITH_YOUR_FRIENDS_ICON:
        return <CompeteWithYourFriends fill={Colors.whiteTwo} />
      case BE_A_VR_CRICKETER_ICON:
        return <BeAVrCricketStar fill={Colors.whiteTwo} />
      default:
        return null
    }
  }

  renderStadiumComponent = playInInternationalStrip => (
    <PlayInInternationalStadiumStripContainer>
      {playInInternationalStrip.map(stadium => (
        <PlayInInternationalStadiumInnerContainer>
          <PlayInInternationalStadiumSvgContainer>
            {this.getIcon(stadium.svg)}
          </PlayInInternationalStadiumSvgContainer>
          <PlayInInternationalStadiumText as="h2">
            {stadium.description}
          </PlayInInternationalStadiumText>
        </PlayInInternationalStadiumInnerContainer>
      ))}
    </PlayInInternationalStadiumStripContainer>
  )

  render() {
    const { playInInternationalStrip } = this.props
    return (
      <PlayInInternationalStadiumStripSection
        className="sub-nav-hero-container"
        id={`arcade-international-strip-section`}
      >
        <PlayInStripContainer>
          {this.renderStadiumComponent(playInInternationalStrip)}
        </PlayInStripContainer>
      </PlayInInternationalStadiumStripSection>
    )
  }
}

export default PlayInInternationalStadiumStrip



// WEBPACK FOOTER //
// ./src/components/IbcArcade/PlayInInternationalStrip/index.js